import { h, render, hydrate } from 'preact';
import './styles/main.scss';
import { ProductRecommendationsSection } from './pages/ProductRecommendationsSection';
// Support multiple recommendation widgets: use attribute recommendation-app.
// Fall back to single element with id "recommendation-app" for backward compatibility.
const mountElements = document.querySelectorAll('[recommendation-app]');
const mountList = mountElements.length > 0
    ? Array.from(mountElements)
    : (() => {
        const el = document.getElementById('recommendation-app');
        return el ? [el] : [];
    })();
mountList.forEach((mountElement) => {
    if (mountElement.hasChildNodes()) {
        hydrate(h(ProductRecommendationsSection, { containerElement: mountElement }), mountElement);
    }
    else {
        render(h(ProductRecommendationsSection, { containerElement: mountElement }), mountElement);
    }
    mountElement.setAttribute('initialized', '');
});
